module.exports = __webpack_public_path__ + "static/media/i_v teacher3.15966ece.svg";